// Filter and Load more via ajax
const cardList = document.querySelector('.sc-news-list');

if (cardList) {
  const params = new URLSearchParams(window.location.search);
  const urlPage = parseInt(params.get('pageNumber') || '1', 10);

  cardList.dataset.currentPage = String(urlPage);

  const getActiveCategoryId = () => {
    const active = cardList.querySelector('button.news-list__filter.is-active');
    return active ? active.dataset.id : '';
  };

  const axiosGetCardList = async (parent, pageNumber, mode = 'replace') => {
    let [baseUrl] = window.location.href.split('?');
    baseUrl = `${baseUrl}?`;
    const initCategory = parent.getAttribute('data-category');
    const activeCategory = getActiveCategoryId();
    const activeFilter = cardList.querySelector('button.news-list__filter.is-active');
    if (activeFilter && activeFilter.dataset.href) {
      baseUrl = `${activeFilter.dataset.href}&`;
    }
    const listInner = parent.querySelector('.news-list__items');
    const mainCardInner = parent.querySelector('.news-list__main-card');
    const loadMoreWrap = parent.querySelector('.news-list__more');

    loadMoreWrap?.classList.add('is-loading');

    try {
      const { data } = await axios.post(localData.siteURL, {
        id: localData?.id || '',
        action: 'getMoreNews',
        initCategory,
        activeCategory,
        pageNumber,
      });

      if (mode === 'replace') {
        if (mainCardInner) {
          mainCardInner.innerHTML = (data?.data?.main_card || '').trim();
        }
        if (listInner) {
          listInner.innerHTML = (data?.data?.html_list || '').trim();
        }
      } else if (mode === 'append') {
        if (listInner && data?.data?.html_list) {
          listInner.insertAdjacentHTML('beforeend', data.data.html_list.trim());
        }
      }

      if (loadMoreWrap) {
        loadMoreWrap.style.display = data?.data?.has_more ? '' : 'none';
      }

      const urlParams = [
        {
          key: 'pageNumber',
          value: pageNumber,
        },
        {
          key: 'category',
          value: activeCategory && activeCategory !== '0' ? activeCategory : '',
        },
      ]
        .filter((item) => String(item.value).length > 0)
        .map((item) => `${item.key}=${item.value}`)
        .join('&');
      window.history.pushState({}, '', baseUrl + (urlParams ? `${urlParams}` : ''));
      cardList.dataset.currentPage = pageNumber;
    } catch (err) {
      console.error(err);
    } finally {
      loadMoreWrap?.classList.remove('is-loading');
    }
  };

  // Filter buttons
  attachEvent('button.news-list__filter', 'click', (ev) => {
    ev.preventDefault();
    const clicked = ev.target.closest('button.news-list__filter');
    if (!clicked) return;

    cardList.querySelectorAll('button.news-list__filter').forEach((btn) => {
      btn.classList.remove('is-active');
    });
    clicked.classList.add('is-active');

    const parent = clicked.closest('.sc-news-list');
    axiosGetCardList(parent, 1, 'replace');
  });

  // Load more button
  attachEvent('.news-list__more button', 'click', (ev) => {
    ev.preventDefault();
    const clicked = ev.target.closest('.news-list__more button');
    if (!clicked) return;

    const parent = cardList;
    const currentPage = parseInt(parent.dataset.currentPage || '1', 10);
    axiosGetCardList(parent, currentPage + 1, 'append');
  });
}
